/*
 * Copyright (c) 2021.
 * kurokeita
 */

/**
 * @param {*} state
 * @param {*} action
 */
import {
    COMPANY_APP_ACTION_SUCCESS, COMPANY_APP_LIST_SUCCESS
} from "../../types";

const CompanyAppReducer = (state = {}, action) => {
    if (action.payload === undefined || action.payload === false) return state;

    switch (action.type) {
        case COMPANY_APP_ACTION_SUCCESS:
            return {...state, action}
        case COMPANY_APP_LIST_SUCCESS:
            let appList = action.payload.data.data
            appList.map((app) => {
                let id = app['app_id']
                state[id] = app
                return true
            });

            return {...state, action}

        default:
            return state;
    }
};

export {CompanyAppReducer}